import { createSelector } from '@ngrx/store';
import { getLegalEntity } from '@cemex/cmx-client-layout';
import { getOneClickState } from '@ordersnproducts/modules/one-click-order/reducers';

export const getCustomerAndOneClickState = createSelector(
  getLegalEntity,
  getOneClickState,
  (customer, oneClickState) => ({
    legalEntity: customer,
    state: oneClickState,
  }),
);
